import { combineReducers } from 'redux';

import IssueTypeDataReducer from './IssueTypes/IssueTypes';
import SelectedIssueDataReducer from './SelectedIssue/SelectedIssue';
import SettingsDataReducer from './Settings/Settings';

export default combineReducers({
    issueTypes: IssueTypeDataReducer,
    selectedIssue: SelectedIssueDataReducer,
    settings: SettingsDataReducer
});